import { render, staticRenderFns } from "./GameProfileLink.vue?vue&type=template&id=03755da4&scoped=true"
import script from "./GameProfileLink.vue?vue&type=script&lang=js"
export * from "./GameProfileLink.vue?vue&type=script&lang=js"
import style0 from "./GameProfileLink.vue?vue&type=style&index=0&id=03755da4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03755da4",
  null
  
)

export default component.exports